"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Houses = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _HousesFilters = require("./inner/HousesFilters");
var _Row = require("../Grid/Row");
var _Cell = require("../Grid/Cell");
var _Escrow = require("./inner/Escrow");
var _Footer = require("../Footer/Footer");
var _Documents = require("./inner/Documents");
var _Deadlines = require("../Deadlines/Deadlines");
var _Deadline = require("../Deadlines/Deadline");
var styles = _interopRequireWildcard(require("./Houses.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Houses = _ref => {
  let {
    houses,
    onEscrowIconClick
  } = _ref;
  const [selectedHouseId, setOpenHouseId] = React.useState(houses[0]?.id);
  const currentHouse = houses.find(house => house.id === selectedHouseId) || houses[0];
  if (!selectedHouseId) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, "\u041A\u043E\u0440\u043F\u0443\u0441\u0430")), /*#__PURE__*/React.createElement("div", {
    className: styles['filters']
  }, houses.length > 1 ? /*#__PURE__*/React.createElement(_HousesFilters.HousesFilters, {
    houses: houses,
    selectedHouseId: selectedHouseId,
    onClick: setOpenHouseId
  }) : houses[0].name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Row.Row, null, /*#__PURE__*/React.createElement(_Cell.Cell, null, /*#__PURE__*/React.createElement(_Escrow.Escrow, {
    onEscrowIconClick: onEscrowIconClick,
    escrow: currentHouse.escrow
  }))), /*#__PURE__*/React.createElement(_Deadlines.Deadlines, null, currentHouse.deadlines.map((deadline, i) => {
    return /*#__PURE__*/React.createElement(_Deadline.Deadline, {
      key: i,
      deadline: deadline
    });
  })), /*#__PURE__*/React.createElement(_Documents.Documents, {
    documents: currentHouse.documents,
    documentsCount: currentHouse.documentsCount,
    documentsCountHasWarning: currentHouse.documentsCountHasWarning
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Footer.Footer, {
    fullwidth: false,
    url: currentHouse.offersLink
  })));
};
exports.Houses = Houses;